export class EngagementStats {
    static jsonMap = {
        pourcentageEngagementVer: { key: 'pourcentageEngagementVer', optional: true },
        nombreControleEnCours: { key: 'nombreControleEnCours', optional: true },
        nombreAdherentsAgrees: { key: 'nombreAdherentsAgrees', optional: true }
    };

    public pourcentageEngagementVer: number = undefined;
    public nombreControleEnCours: number = undefined;
    public nombreAdherentsAgrees: number = undefined;
}
